import actions from "@/store/modules/contract/actions";
import mutations from "@/store/modules/contract/mutations";
import state from "@/store/modules/contract/state";

export default {
    actions,
    mutations,
    state
}